<script lang="ts" setup>
import { cn } from "@/lib/utils";
import {
    CalendarCell,
    type CalendarCellProps,
    useForwardProps,
} from "radix-vue";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
    CalendarCellProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <CalendarCell
        :class="
            cn(
                'h-9 w-9 p-0 text-sm [&:has([data-selected])]:rounded-md [&:has([data-selected])]:bg-stone-100 [&:has([data-selected][data-outside-view])]:bg-stone-100/50 dark:[&:has([data-selected])]:bg-stone-800 dark:[&:has([data-selected][data-outside-view])]:bg-stone-800/50 relative text-center focus-within:relative focus-within:z-20',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarCell>
</template>
